import { SurfaceConstants } from 'owa-calendar-surface-core';

/**
 * Returns lineHeight value for a specific container
 */
export default function getLineHeight(item: HTMLElement): number {
    // Currently returns the default browser line height
    let lineHeight = SurfaceConstants.subjectLineHeight;
    return lineHeight;
}
